module.exports = __webpack_public_path__ + "static/dave-slatyer-974f5d33a283524d75b30c622e5d8aec.png";